import { Link } from "react-router-dom";
import { formatSignalTime } from "../../../lib/dates";
import { signalDetailPath } from "../../../routes/route-paths";
import { SignalActionBadge } from "./SignalActionBadge";

interface SignalRowProps {
  signal: {
    id: string;
    action: number;
    symbol: string;
    receivedAt: string;
  };
  /** The line under the instrument: the strategy on the Signals page, "This signal" or nothing on a details page. */
  caption: string;
  current?: boolean;
}

/** One signal as a row that opens its details page. */
export function SignalRow({ signal, caption, current = false }: SignalRowProps) {
  return (
    <Link
      to={signalDetailPath(signal.id)}
      className={`list-group-item list-group-item-action d-flex flex-wrap align-items-center column-gap-3 row-gap-1 py-3${current ? " tinted-info" : ""}`}
      aria-current={current ? "true" : undefined}
    >
      <span className="font-monospace small" style={{ minWidth: "8.5rem" }}>
        {formatSignalTime(signal.receivedAt)}
      </span>
      <SignalActionBadge action={signal.action} />
      <span className="flex-grow-1" style={{ minWidth: 0 }}>
        <span className="fw-semibold d-block">{signal.symbol}</span>
        {caption && <span className="small d-block text-truncate text-body-secondary">{caption}</span>}
      </span>
    </Link>
  );
}
